'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconXmark, iconXmarkTag } from '@ni/nimble-components/dist/esm/icons/xmark';
import { wrap } from '../../utilities/react-wrapper';

export type { IconXmark };
export { iconXmarkTag };
export const NimbleIconXmark = wrap(IconXmark);